module.exports = __webpack_public_path__ + "img/arrows.8a07c97c.svg";